import { Create } from "react-admin";
import { CategoryForm } from "./CategoryForm";

export const CategoryCreate = (props) => (
  <Create title="Criação de Categoria" {...props}>
    <CategoryForm {...props} />
  </Create>
);
